import React from "react";
import Alert from "@material-ui/lab/Alert";
import TextField from "@material-ui/core/TextField";
import {
  Container,
  Button,
  Typography,
  Box,
  Grid,
  Divider,
  CircularProgress,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import CardMembershipIcon from "@material-ui/icons/CardMembership";
import SettingsIcon from "@material-ui/icons/Settings";
import DirectionsWalkIcon from "@material-ui/icons/DirectionsWalk";
import MapIcon from "@material-ui/icons/Map";
import ExtensionIcon from "@material-ui/icons/Extension";
import SwapHorizIcon from "@material-ui/icons/SwapHoriz";
import ReceiptIcon from "@material-ui/icons/Receipt";
import CancelIcon from "@material-ui/icons/Cancel";
import TimerIcon from "@material-ui/icons/Timer";
import SecurityIcon from "@material-ui/icons/Security";
import InfoIcon from "@material-ui/icons/Info";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import Dialog from "@material-ui/core/Dialog";

import MainAppBar from "../../components/MainAppBar";
import LoadingView from "../../components/loadingView";
import NoSubscriptionBanner from "../home/components/noSubscriptionBanner";
import DialogWarning from "../../components/dialogWarning";
import DisableToursPopover from "../../../utils/disableToursPopover";
import FloatingVideoLink from "../../components/floatingVideoLinks";
import LimitProgressIndicator from "../../../utils/limitProgressIndicator";
import InfoPopover from "../../../utils/informationButton";
import CustomAlert from "../../components/CustomAlert/CustomAlert";
import CommissionInvoicesCard from "../../components/commissionInvoices/commissionInvoicesCard";
import { EuroRounded, MoneyRounded, MoneyTwoTone } from "@material-ui/icons";

const AccountView = (props) => {
  const { t } = useTranslation();

  return (
    <>
      <MainAppBar
        headerText={t("account.title")}
        showHomeButton={true}
        showAdminButton={props.state.isAdmin}
      />
      <Box
        style={{
          backgroundColor: "#F6F8FA",
          minHeight: "100vh",
        }}
        className={props.classes.mainContent}
      >
        <Container maxWidth="lg" style={{ padding: "24px" }}>
          <Box mb={4} className={props.classes.headerContainer}>
            <Typography
              variant="h4"
              style={{
                fontSize: "1.75rem",
                fontWeight: 600,
                color: "#1a1f36",
                marginBottom: "8px",
              }}
            >
              {t("account.title")}
            </Typography>
            <Typography
              variant="subtitle1"
              style={{
                color: "#697386",
                fontSize: "0.875rem",
              }}
            >
              {t("account.manage_info")}
            </Typography>
          </Box>
          <NoSubscriptionBanner
            role={props.state.account?.role}
            hasTrial={props.state.account?.hasTrial}
            redirectToSelectedPack={props.state.account?.redirectToSelectedPack}
            classes={props.classes}
          ></NoSubscriptionBanner>
          <DisableToursPopover
            userOpenedPopover={props.state.isDisableToursOpened}
            excludePage={true}
          />
          <form
            className={props.classes.form}
            autoComplete="off"
            onSubmit={props.submitForm}
          >
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Box
                  style={{
                    backgroundColor: "white",
                    borderRadius: "24px",
                    padding: "32px 40px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
                    border: "1px solid #E0E0E0",
                    height: "100%",
                  }}
                >
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 24,
                    }}
                  >
                    <AccountCircleIcon
                      style={{
                        fontSize: 28,
                        color: "#3F51B5",
                        marginRight: 12,
                      }}
                    />
                    <Typography variant="h6" style={{ fontWeight: 600 }}>
                      {t("account_view.personal_info")}
                    </Typography>
                  </Box>

                  <Box
                    style={{ display: "flex", flexDirection: "column", gap: 4 }}
                  >
                    <Divider style={{ borderColor: "#E0E0E0" }} />

                    <Box style={{ display: "flex", gap: 2, marginTop: 16 }}>
                      <TextField
                        name="firstName"
                        label={t("account_view.first_name")}
                        defaultValue={props.state.account.firstName}
                        variant="outlined"
                        size="small"
                        onChange={props.updateForm}
                        inputProps={{ maxLength: 25 }}
                        key={
                          props.state.accountLoaded
                            ? "firstNameNotLoaded"
                            : "firstNameLoaded"
                        }
                        style={{
                          backgroundColor: "white",
                          width: "48%",
                          marginRight: "4%",
                        }}
                      />
                      <TextField
                        name="lastName"
                        label={t("account_view.last_name")}
                        defaultValue={props.state.account.lastName}
                        variant="outlined"
                        size="small"
                        onChange={props.updateForm}
                        inputProps={{ maxLength: 25 }}
                        key={
                          props.state.accountLoaded
                            ? "lastNameNotLoaded"
                            : "lastNameLoaded"
                        }
                        style={{
                          backgroundColor: "white",
                          width: "48%",
                        }}
                      />
                    </Box>

                    <TextField
                      disabled
                      id="outlined-disabled"
                      defaultValue={props.state.account.email}
                      label={t("account_view.email")}
                      variant="outlined"
                      size="small"
                      key={
                        props.state.accountLoaded
                          ? "emailNotLoaded"
                          : "emailLoaded"
                      }
                      style={{
                        backgroundColor: "white",
                      }}
                    />

                    {/* Raison sociale facultative ici : elle est demandée à
                        l'inscription et doit rester modifiable. L'écran
                        « identité légale de facturation » l'exige en revanche
                        pour vendre. */}
                    <TextField
                      name="company"
                      label={t("account_view.company")}
                      defaultValue={props.state.account.company}
                      variant="outlined"
                      size="small"
                      onChange={props.updateForm}
                      inputProps={{ maxLength: 35 }}
                      key={
                        props.state.accountLoaded
                          ? "companyNotLoaded"
                          : "companyNameLoaded"
                      }
                      style={{
                        backgroundColor: "white",
                      }}
                    />

                    {/* SIRET et adresse restent hors du profil : l'écran
                        identité légale en est la source unique. */}
                    <TextField
                      name="phoneNumber"
                      label={t("account_view.phone")}
                      defaultValue={props.state.account.phoneNumber}
                      variant="outlined"
                      size="small"
                      type="tel"
                      onChange={props.updateForm}
                      inputProps={{ maxLength: 25 }}
                      key={
                        props.state.accountLoaded
                          ? "phoneNumberNotLoaded"
                          : "phoneNumberLoaded"
                      }
                      style={{
                        backgroundColor: "white",
                      }}
                    />

                    <Box
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "24px",
                      }}
                    >
                      <Button
                        className={props.classes.pillButton}
                        variant="contained"
                        size="small"
                        style={{
                          backgroundColor: "#3F51B5",
                          color: "white",
                          borderRadius: "50px",
                          padding: "8px 24px",
                          fontSize: "0.875rem",
                          textTransform: "none",
                          boxShadow: "none",
                        }}
                        onClick={props.submitForm}
                      >
                        {t("account_view.save")}
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box
                  style={{
                    backgroundColor: "white",
                    borderRadius: "24px",
                    padding: "32px 40px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
                    border: "1px solid #E0E0E0",
                    height: "100%",
                  }}
                >
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 24,
                    }}
                  >
                    <CardMembershipIcon
                      style={{
                        fontSize: 28,
                        color: "#3F51B5",
                        marginRight: 12,
                      }}
                    />
                    <Typography variant="h6" style={{ fontWeight: 600 }}>
                      {t("account.subscription_management")}
                    </Typography>
                  </Box>

                  <Box
                    style={{ display: "flex", flexDirection: "column", gap: 4 }}
                  >
                    <Divider style={{ borderColor: "#E0E0E0" }} />
                    <Box
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "24px",
                        marginBottom: "24px",
                      }}
                    >
                      <Button
                        className={props.classes.pillButton}
                        variant="contained"
                        size="small"
                        style={{
                          backgroundColor: "#3F51B5",
                          color: "white",
                          borderRadius: "50px",
                          padding: "8px 24px",
                          fontSize: "0.875rem",
                          textTransform: "none",
                          boxShadow: "none",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                        onClick={() => {
                          props.openDeactivatedTours(true);
                        }}
                      >
                        <SettingsIcon style={{ fontSize: 20 }} />
                        {t("account.toggle_tours")}
                      </Button>
                    </Box>
                    {!props.state.account
                      .userAskedCreationAccountStripeConnect ? (
                      <Link
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginBottom: "24px",
                          textDecoration: "none",
                        }}
                        to="/request-stripe-connect-account"
                      >
                        <Button
                          className={props.classes.pillButton}
                          variant="contained"
                          size="small"
                          style={{
                            backgroundColor: "green",
                            color: "white",
                            borderRadius: "50px",
                            padding: "8px 24px",
                            fontSize: "0.875rem",
                            textTransform: "none",
                            boxShadow: "none",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <EuroRounded style={{ fontSize: 20 }} />
                          {t("account.request_stripe_connect_account")}
                        </Button>
                      </Link>
                    ) : !props.state.account.accountStripeConnectAuthorized &&
                      !props.state.account.accountStripeConnectRejected &&
                      !props.state.account.accountStripeConnectActive ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginBottom: 12,
                        }}
                      >
                        <Box
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "24px",
                            backgroundColor: "#f8f9fa",
                            borderRadius: "12px",
                            marginTop: "16px",
                            marginBottom: "24px",
                          }}
                        >
                          <Typography
                            variant="body1"
                            style={{
                              color: "#1a1f36",
                              textAlign: "center",
                              fontWeight: 500,
                            }}
                          >
                            {t("account.request_processing")}
                          </Typography>
                        </Box>
                      </div>
                    ) : props.state.account?.stripeConnectUserId ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginBottom: 12,
                        }}
                      >
                        <Button
                          className={props.classes.pillButton}
                          variant="contained"
                          size="small"
                          style={{
                            backgroundColor: "green",
                            color: "white",
                            borderRadius: "50px",
                            padding: "8px 24px",
                            fontSize: "0.875rem",
                            textTransform: "none",
                            boxShadow: "none",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                          onClick={props.handleGoToStripeConnectAccount}
                          disabled={props.state.isStripeConnectLoading}
                        >
                          {props.state.isStripeConnectLoading ? (
                            <CircularProgress
                              size={20}
                              style={{ color: "white" }}
                            />
                          ) : (
                            <>
                              <EuroRounded style={{ fontSize: 20 }} />
                              {t("account.go_to_connect_account")}
                            </>
                          )}
                        </Button>
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginBottom: 12,
                        }}
                      >
                        <Button
                          className={props.classes.pillButton}
                          variant="contained"
                          size="small"
                          style={{
                            backgroundColor: "green",
                            color: "white",
                            borderRadius: "50px",
                            padding: "8px 24px",
                            fontSize: "0.875rem",
                            textTransform: "none",
                            boxShadow: "none",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                          onClick={props.handleStripeConnectSignup}
                          disabled={props.state.isStripeConnectLoading}
                        >
                          {props.state.isStripeConnectLoading ? (
                            <CircularProgress
                              size={20}
                              style={{ color: "white" }}
                            />
                          ) : (
                            <>
                              <EuroRounded style={{ fontSize: 20 }} />
                              {t("account.create_connect_account")}
                            </>
                          )}
                        </Button>
                      </div>
                    )}
                    <Box
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        backgroundColor: "#F3F4F6",
                        borderRadius: "12px",
                        padding: "16px",
                        marginBottom: "24px",
                      }}
                    >
                      <Typography
                        style={{
                          fontSize: "1rem",
                          color: "#1F2937",
                          fontWeight: 600,
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <CardMembershipIcon
                          style={{ fontSize: 24, color: "#3F51B5" }}
                        />
                        {props.state.account.role === "PACK_DECOUVERTE"
                          ? t("account.pack_discovery")
                          : props.state.account.role === "PACK_AVENTURE"
                            ? t("account.pack_adventure")
                            : props.state.account.role === "PACK_EXPERT"
                              ? t("account.pack_expert")
                              : props.state.account.role === "NO_SUBSCRIBTION" ||
                                props.state.account.role === "NEW_MEMBER"
                                ? t("account.no_subscription")
                                : props.state.account.role === "ADMIN"
                                  ? t("account.admin")
                                  : t("account.no_subscription")}
                      </Typography>
                    </Box>
                    <Box
                      className={props.classes.statsRow}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 8,
                        marginBottom: "24px",
                      }}
                    >
                      <Box
                        className={props.classes.statCard}
                        style={{
                          backgroundColor: "#F3F4F6",
                          borderRadius: "16px",
                          padding: "24px",
                          flex: 1,
                          textAlign: "center",
                          transition: "all 0.2s ease",
                          "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                          },
                        }}
                      >
                        <DirectionsWalkIcon
                          style={{
                            fontSize: 32,
                            color: "#3F51B5",
                            marginBottom: "8px",
                          }}
                        />
                        <Typography
                          style={{ marginBottom: 2, color: "#6B7280" }}
                        >
                          {t("account.max_tours")}
                        </Typography>
                        <Typography
                          variant="h3"
                          style={{ fontWeight: 600, color: "#1F2937" }}
                        >
                          {props.state.account.maxNbOfTours}
                        </Typography>
                      </Box>

                      <Box
                        className={props.classes.statCard}
                        style={{
                          backgroundColor: "#F3F4F6",
                          borderRadius: "16px",
                          padding: "24px",
                          flex: 1,
                          textAlign: "center",
                          transition: "all 0.2s ease",
                          "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                          },
                        }}
                      >
                        <MapIcon
                          style={{
                            fontSize: 32,
                            color: "#3F51B5",
                            marginBottom: "8px",
                          }}
                        />
                        <Typography
                          style={{ marginBottom: 2, color: "#6B7280" }}
                        >
                          {t("account.max_zones")}
                        </Typography>
                        <Typography
                          variant="h3"
                          style={{ fontWeight: 600, color: "#1F2937" }}
                        >
                          {props.state.account.maxZones}
                        </Typography>
                      </Box>

                      <Box
                        className={props.classes.statCard}
                        style={{
                          backgroundColor: "#F3F4F6",
                          borderRadius: "16px",
                          padding: "24px",
                          flex: 1,
                          textAlign: "center",
                          transition: "all 0.2s ease",
                          "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                          },
                        }}
                      >
                        <ExtensionIcon
                          style={{
                            fontSize: 32,
                            color: "#3F51B5",
                            marginBottom: "8px",
                          }}
                        />
                        <Typography
                          style={{ marginBottom: 2, color: "#6B7280" }}
                        >
                          {t("account.max_enigmas")}
                        </Typography>
                        <Typography
                          variant="h3"
                          style={{ fontWeight: 600, color: "#1F2937" }}
                        >
                          {props.state.account.maxEnigmas}
                        </Typography>
                      </Box>
                    </Box>
                    <Box
                      className={props.classes.actionsRow}
                      style={{
                        display: "flex",
                        gap: "16px",
                        justifyContent: "center",
                        margin: "24px 0",
                      }}
                    >
                      <Link to="/subscribe" style={{ textDecoration: "none" }}>
                        <Button
                          className={props.classes.pillButton}
                          variant="contained"
                          size="small"
                          style={{
                            borderRadius: "50px",
                            padding: "8px 24px",
                            backgroundColor: "#3F51B5",
                            color: "white",
                            fontSize: "0.875rem",
                            minWidth: "auto",
                            textTransform: "none",
                            boxShadow: "none",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <SwapHorizIcon style={{ fontSize: 20 }} />
                          {t("account.change_subscription")}
                        </Button>
                      </Link>

                      <Button
                        className={props.classes.pillButton}
                        variant="contained"
                        size="small"
                        style={{
                          borderRadius: "50px",
                          padding: "8px 24px",
                          backgroundColor: "#3F51B5",
                          color: "white",
                          fontSize: "0.875rem",
                          minWidth: "auto",
                          textTransform: "none",
                          boxShadow: "none",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                        onClick={props.getCustomerPortalSession}
                      >
                        <ReceiptIcon style={{ fontSize: 20 }} />
                        {t("account.billing")}
                      </Button>

                      <Button
                        className={props.classes.pillButton}
                        variant="contained"
                        size="small"
                        style={{
                          borderRadius: "50px",
                          padding: "8px 24px",
                          backgroundColor: "#DC3545",
                          color: "white",
                          fontSize: "0.875rem",
                          minWidth: "auto",
                          textTransform: "none",
                          boxShadow: "none",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                        onClick={props.openDialog}
                      >
                        <CancelIcon style={{ fontSize: 20 }} />
                        {t("account.cancel_subscription")}
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
            <DialogWarning
              open={props.state.dialogWaringOpened}
              primaryText={t("account_view.confirm_cancel_subscription_title")}
              secondaryText={t("account_view.confirm_cancel_subscription_text")}
              primaryAction={props.onCancelSubscription}
              closeAction={props.closeDialog}
              primaryButtonText={t("button.confirm")}
              secondaryButtonText={t("button.cancel")}
            />

            <Grid container spacing={3} style={{ marginTop: "24px" }}>
              <Grid item xs={12} md={3}>
                <Box
                  style={{
                    backgroundColor: "white",
                    borderRadius: "24px",
                    padding: "32px 40px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
                    border: "1px solid #E0E0E0",
                    height: "100%",
                  }}
                >
                  <Box className={props.classes.aiCreditsHeader}>
                    <Typography className={props.classes.aiCreditsTitle}>
                      {t("account.ai_credits")}
                    </Typography>
                    <Box
                      component="span"
                      style={{
                        fontSize: "24px",
                        animation: "pulse 2s infinite",
                      }}
                    >
                      ✨
                    </Box>
                  </Box>
                  <Box className={props.classes.aiCreditsValue}>
                    <Typography className={props.classes.aiCreditsNumber}>
                      {props.state.account.aiCredits}
                    </Typography>
                    <Typography className={props.classes.aiCreditsLabel}>
                      {t("account.remaining_credits")}
                    </Typography>
                  </Box>
                  <Button
                    variant="contained"
                    className={props.classes.rechargeButton}
                    fullWidth
                    onClick={props.handleSubscriptionSelect}
                  >
                    {t("account.reload_credits")}
                  </Button>
                </Box>
              </Grid>

              <Grid item xs={12} md={3}>
                <Box
                  style={{
                    backgroundColor: "white",
                    borderRadius: "24px",
                    padding: "32px 40px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
                    border: "1px solid #E0E0E0",
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "24px",
                  }}
                >
                  <Box style={{ display: "flex", alignItems: "center" }}>
                    <SecurityIcon
                      style={{
                        fontSize: 28,
                        color: "#3F51B5",
                        marginRight: 12,
                      }}
                    />
                    <Typography variant="h6" style={{ fontWeight: 600 }}>
                      {t("account.admin_code")}
                    </Typography>
                  </Box>

                  <Box
                    className={props.classes.statCard}
                    style={{
                      backgroundColor: "#F3F4F6",
                      borderRadius: "16px",
                      padding: "32px",
                      border: "1px solid #E0E0E0",
                      width: "100%",
                      minHeight: "120px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                      transition: "all 0.2s ease",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                      },
                    }}
                  >
                    <Typography
                      className={props.classes.adminCode}
                      variant="h3"
                      style={{
                        fontWeight: 600,
                        color: "#1F2937",
                        margin: 0,
                        lineHeight: 1,
                        fontSize: "2.5rem",
                        letterSpacing: "2px",
                      }}
                    >
                      {props.state.account.adminCode}
                    </Typography>
                    <Typography
                      style={{
                        color: "#6B7280",
                        fontSize: "0.875rem",
                        textAlign: "center",
                      }}
                    >
                      {t("account.admin_code_info")}
                    </Typography>
                  </Box>

                  <Box
                    style={{
                      backgroundColor: "#F3F4F6",
                      borderRadius: "12px",
                      padding: "16px",
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <InfoIcon style={{ fontSize: 20, color: "#3F51B5" }} />
                    <Typography
                      style={{
                        fontSize: "0.875rem",
                        color: "#6B7280",
                      }}
                    >
                      {t("account.admin_code_warning")}
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box
                  style={{
                    backgroundColor: "white",
                    borderRadius: "24px",
                    padding: "32px 40px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
                    border: "1px solid #E0E0E0",
                    height: "100%",
                  }}
                >
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 24,
                    }}
                  >
                    <TimerIcon
                      style={{
                        fontSize: 28,
                        color: "#3F51B5",
                        marginRight: 12,
                      }}
                    />
                    <Typography variant="h6" style={{ fontWeight: 600 }}>
                      {t("account.sessions_count")}
                    </Typography>
                  </Box>

                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "16px",
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6} md={4}>
                        <Box
                          style={{
                            backgroundColor: "#F3F4F6",
                            borderRadius: "16px",
                            padding: "24px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "8px",
                            height: "100%",
                          }}
                        >
                          <Typography
                            style={{
                              fontSize: "0.875rem",
                              color: "#6B7280",
                            }}
                          >
                            {t("account.used_sessions")}
                          </Typography>
                          <Typography
                            style={{
                              fontSize: "2rem",
                              fontWeight: 600,
                              color: "#1F2937",
                            }}
                          >
                            {props.state.account.analyticsCountMonth || 0}
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={6} md={4}>
                        <Box
                          style={{
                            backgroundColor: "#3F51B5",
                            borderRadius: "16px",
                            padding: "24px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "8px",
                            color: "white",
                            height: "100%",
                          }}
                        >
                          <Typography
                            style={{
                              fontSize: "0.875rem",
                              opacity: 0.9,
                            }}
                          >
                            {t("account.free_sessions")}
                          </Typography>
                          <Typography
                            style={{
                              fontSize: "2rem",
                              fontWeight: 600,
                            }}
                          >
                            {props.state.account.maxSessionsPerMonth}
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={12} md={4}>
                        <Box
                          style={{
                            backgroundColor: "#F3F4F6",
                            borderRadius: "16px",
                            padding: "24px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "8px",
                            height: "100%",
                          }}
                        >
                          <Box
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <Typography
                              style={{
                                fontSize: "0.875rem",
                                color: "#6B7280",
                              }}
                            >
                              {t("account.max_sessions")}
                            </Typography>
                            <InfoPopover
                              text={t("account_view.session_month_infos_text")}
                            />
                          </Box>

                          <TextField
                            value={props.state.account.limitSessionPerMonth}
                            onChange={props.updateForm}
                            name="limitSessionPerMonth"
                            type="number"
                            variant="outlined"
                            size="small"
                            disabled={
                              props.state.account.role === "NEW_MEMBER" ||
                              props.state.account.role === "NO_SUBSCRIBTION"
                            }
                            InputProps={{
                              style: {
                                fontSize: "2rem",
                                fontWeight: 600,
                                width: "100px",
                                textAlign: "center",
                                color:
                                  props.state.account.role === "NEW_MEMBER" ||
                                    props.state.account.role === "NO_SUBSCRIBTION"
                                    ? "#9CA3AF"
                                    : "#1F2937",
                                backgroundColor:
                                  props.state.account.role === "NEW_MEMBER" ||
                                    props.state.account.role === "NO_SUBSCRIBTION"
                                    ? "#F3F4F6"
                                    : "white",
                                borderRadius: "8px",
                                padding: "4px",
                              },
                            }}
                            style={{
                              marginTop: "4px",
                              marginLeft: "34px",
                            }}
                          />
                        </Box>
                      </Grid>
                    </Grid>

                    <Box
                      style={{
                        backgroundColor: "#F3F4F6",
                        borderRadius: "16px",
                        padding: "24px",
                        marginTop: "8px",
                        width: "100%",
                      }}
                    >
                      <LimitProgressIndicator
                        value={
                          props.state.account.analyticsCountMonth
                            ? props.state.account.analyticsCountMonth
                            : 0
                        }
                        freeSessionsLimit={
                          props.state.account.maxSessionsPerMonth
                        }
                        maxSessionsLimit={
                          props.state.account.limitSessionPerMonth
                        }
                        reinitializeDate={
                          props.state.account.analyticsCountMonthReinitialize
                        }
                        style={{ width: "100%" }}
                      />
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>

            <CustomAlert
              severity="error"
              message={props.state.errorMessage}
              duration={5000}
              onClose={props.resetErrorAlert}
              height={10}
            />

            <CustomAlert
              severity="success"
              message={props.state.successMessage}
              duration={5000}
              onClose={props.resetSuccessAlert}
              height={10}
            />
          </form>
        </Container>
        <Container maxWidth="lg" style={{ padding: "0 24px" }}>
          {/* Hors du <form> : le bouton de téléchargement ne doit pas
              déclencher la soumission du profil. */}
          <CommissionInvoicesCard
            invoices={props.state.commissionInvoices}
            isLoading={props.state.commissionInvoicesLoading}
            downloadingInvoiceId={props.state.downloadingInvoiceId}
            onDownload={props.handleDownloadCommissionInvoice}
          />
          <Box className={props.classes.dangerZoneCard}>
            <Typography className={props.classes.dangerZoneTitle}>
              {t("delete_account.danger_zone_title")}
            </Typography>
            <Typography className={props.classes.dangerZoneDescription}>
              {t("delete_account.danger_zone_description")}
            </Typography>
            <Button
              className={props.classes.deleteAccountButton}
              onClick={props.openDeleteAccountDialog}
              startIcon={<DeleteForeverIcon />}
            >
              {t("delete_account.button")}
            </Button>
          </Box>
        </Container>
      </Box>


      <Dialog
        open={props.state.deleteAccountDialogOpened}
        onClose={props.closeDeleteAccountDialog}
        className={props.classes.deleteAccountDialog}
      >
        <Box className={props.classes.deleteDialogIcon}>
          <DeleteForeverIcon style={{ fontSize: 56, color: "#EF4444" }} />
        </Box>
        <Typography className={props.classes.deleteDialogTitle}>
          {t("delete_account.dialog_title")}
        </Typography>
        <Typography className={props.classes.deleteDialogText}>
          {t("delete_account.dialog_text")
            .split("\n")
            .map((line, i) => (
              <React.Fragment key={i}>
                {line}
                {i < t("delete_account.dialog_text").split("\n").length - 1 && (
                  <><br /><br /></>
                )}
              </React.Fragment>
            ))}
        </Typography>
        <Typography className={props.classes.deleteDialogInstruction}>
          {t("delete_account.confirm_instruction")}
        </Typography>
        <TextField
          variant="outlined"
          placeholder={t("delete_account.confirm_word")}
          value={props.state.deleteAccountConfirmText}
          onChange={props.updateDeleteAccountConfirmText}
          fullWidth
          autoComplete="off"
          className={props.classes.deleteDialogInput}
        />
        <Box className={props.classes.deleteDialogActions}>
          <Button
            className={props.classes.deleteDialogCancelButton}
            onClick={props.closeDeleteAccountDialog}
          >
            {t("delete_account.cancel_button")}
          </Button>
          <Button
            className={props.classes.deleteDialogConfirmButton}
            onClick={props.onDeleteAccount}
            disabled={
              props.state.deleteAccountConfirmText !==
              t("delete_account.confirm_word")
            }
          >
            {t("delete_account.confirm_button")}
          </Button>
        </Box>
      </Dialog>
    </>
  );
};

export default AccountView;
